import React, { useEffect } from "react";

export default function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onCancel?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  if (!open) return null;

  const confirmClasses = destructive
    ? "bg-red-500 hover:bg-red-400 text-zinc-50 shadow-lg shadow-red-500/30"
    : "bg-emerald-500 hover:bg-emerald-400 text-zinc-950";

  return (
    <div
      className="fixed inset-0 z-[90] bg-black/60 backdrop-blur-sm grid place-items-center p-6"
      onClick={onCancel}
    >
      <div
        className="bg-zinc-950 border border-zinc-800 rounded-2xl w-full max-w-sm
                   p-6 animate-scale-in shadow-2xl shadow-black/50"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-bold text-zinc-100 mb-2">{title}</h3>
        {description && (
          <p className="text-sm text-zinc-400 mb-6 leading-relaxed">
            {description}
          </p>
        )}
        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2.5 rounded-full bg-zinc-900 border border-zinc-800
                       text-sm font-semibold text-zinc-200 hover:border-zinc-700 transition"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`px-5 py-2.5 rounded-full font-semibold text-sm transition ${confirmClasses}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
